export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informationen über die Gegenpartei"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Konto / E-Mail / Telefon"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Krypto-Adresse / E-Mail / Telefon"])}
}